const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  header: {
    background: 'white',
    color: theme.palette.primary.main,
    padding: 16, 
    display:'flex',
    '& h1': {
      fontWeight:500,
      textTransform: 'uppercase',
      fontSize: '1.4rem',
      display:'flex',
      flexGrow: 1,
      lineHeight: '40px'
    },
    '& button': {
  
    },
  },
  contents: {
    padding: 16
  },
  footer: {
    padding: 16,
    background: theme.palette.grey[50]
  },
  modal:{},
  draggableModal: {
    display: 'inline-block',
    willChange: 'transform'
  },
  draggableHeader: {
    cursor: 'move',
    userSelect: 'none',
    '& button': {
      cursor: 'pointer'
    }
  },
  form:{
    '& input': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  button:{},
  textField:{},
  block:{},
  logo:{},
  flex: {},
  error:{},
  warning:{},
  list:{},
  listItem:{},
  scrollableList:{},
  logoSelect: {},
  logoPreviewHolder: {},
  logoPreview: {},
  logoButton: {},
  logoButtonAdd: {},
  logoButtonRemove: {},
  logoButtonIcon: {},
  summary: {},
  padded:{},
  modalHeader:{},
  submit: {},
  close: {},
  upload: {},
  save: {},
  truncatelongjobname: {}
})

export default styles
